import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pt: {
    translation: {
      "nav.home": "Início",
      "nav.stackmode": "Stackmode",
      "nav.discord": "Discord",
      "nav.habbold": "Habbold",
      "tips.rollers": "É extremamente importante o uso de rollers e CD's!",
      "tips.pouf": "Empilhamento de pufes.",
      "tips.merge": "E você também pode mesclar!",
      "tips.rugs": "Empilhamento de Tapetinhos.",
      "tips.rugsWithCds": "Empilhamento de Tapetinhos com CDs",
      "tips.rusticCorners": "Empilhamento de cantos Rústicos",
      "tips.partition": "Empilhamento de Divisória",
      "tips.chairOnSofa": "Empilhamento de cadeira em sofá",
      "tips.floorOnDoors": "Empilhamento de Piso em portas",
      "tips.pureShelves": "Empilhamento de Prateleiras Pura",
      "tips.partitionsOnDoors": "Empilhamento de divisórias em portas"
    }
  },
  en: {
    translation: {
      "nav.home": "Home",
      "nav.stackmode": "Stackmode",
      "nav.discord": "Discord",
      "nav.habbold": "Habbold",
      "tips.rollers": "Using rollers and CDs is extremely important!",
      "tips.pouf": "Pod stacking.",
      "tips.merge": "And you can also merge!",
      "tips.rugs": "Doormats stacking.",
      "tips.rugsWithCds": "Doormats stack with CDs",
      "tips.rusticCorners": "Lodge/Cabin/Amberwood Plinth stacking",
      "tips.partition": "Lodge/Cabin/Amberwood Divider stacking",
      "tips.chairOnSofa": "Chair on Sofa stacking",
      "tips.floorOnDoors": "Stacking tiles inside doors",
      "tips.pureShelves": "Pure Shelves stacking",
      "tips.partitionsOnDoors": "Stacking dividers inside doors"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
